import React from "react";
import {
	BooleanField,
	DateField,
	List,
	SelectField,
	TextField,
} from "react-admin";
import Expand from "../../../bookmaker-imports/Expand";
import CsvField from "../../../bookmaker-imports/fields/CsvField";
import StatusField from "../../../bookmaker-imports/fields/StatusField";
import types from "../../../bookmaker-imports/types";
import ResponsiveList from "../../../components/lists/ResponsiveList";
import { useListStyles } from "../../../components/lists/useStyles";
import { getCommonListProps } from "./";

const BookmakerImportsListField = (props) => {
	const classes = useListStyles();
	return (
		<List
			resource="bookmaker-imports"
			basePath="/bookmaker-imports"
			classes={classes}
			{...getCommonListProps(props)}
			hasCreate={false}
			hasEdit={false}
		>
			<ResponsiveList expand={<Expand />}>
				<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
				<SelectField
					source="type"
					variant="overline"
					choices={types}
					label="resources.bookmaker-imports.fields.type"
				/>
				<CsvField
					source="csv.path"
					title="csv.name"
					label="resources.bookmaker-imports.fields.csv"
				/>
				<StatusField source="status" />
				<DateField
					source="date"
					label="resources.bookmaker-imports.fields.date"
				/>
				<DateField
					source="created"
					showTime
					label="resources.bookmaker-imports.fields.created"
				/>
				<BooleanField
					source="is_manually"
					label="resources.bookmaker-imports.fields.is_manually"
				/>
			</ResponsiveList>
		</List>
	);
};

export default BookmakerImportsListField;
